import { render, staticRenderFns } from "./StandaloneLink.vue?vue&type=template&id=3bf5f9c6&scoped=true&lang=pug&"
import script from "./StandaloneLink.vue?vue&type=script&lang=js&"
export * from "./StandaloneLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5f9c6",
  null
  
)

export default component.exports